module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('random_system')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bet-area"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bettingSvc.random),
      expression: "bettingSvc.random"
    }, {
      name: "random-system-validator",
      rawName: "v-random-system-validator"
    }],
    attrs: {
      "id": "random",
      "type": "number",
      "disabled": _vm.isBettingDisabled
    },
    domProps: {
      "value": (_vm.bettingSvc.random)
    },
    on: {
      "keydown": [_vm.checkChars, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }],
      "click": function($event) {
        _vm.setFocus('random')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bettingSvc.random = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('system_bet')))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bettingSvc.system),
      expression: "bettingSvc.system"
    }, {
      name: "system-bet-validator",
      rawName: "v-system-bet-validator"
    }],
    attrs: {
      "id": "system",
      "type": "number",
      "disabled": _vm.isBettingDisabled
    },
    domProps: {
      "value": (_vm.bettingSvc.system)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }],
      "click": function($event) {
        _vm.setFocus('system')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bettingSvc.system = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.bettingSvc.random && _vm.bettingSvc.random > 1) ? _c('label', [_c('span', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bettingSvc.random))])]) : _vm._e(), _vm._v(" "), (!_vm.bettingSvc.random || _vm.bettingSvc.random <= 1) ? _c('label', [_c('span', [_vm._v(_vm._s(_vm._f("translate")('system_no_combinations')))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3729336","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/RandomSystem.vue
// module id = 409
// module chunks = 0